import {ActionCode, ChangeOrderActionCode} from './action'

// See in API: src/services/estimateService.cost.ts :: updateEstimateActualTotal
export const AttachedCoAddsToTotalActionCode: ChangeOrderActionCode[] = ['submitted', 'approve']

export const AttachedTicketAddsToTotalActionCode: ActionCode[] = [
  'cost_submitted', 'cost_reviewed', 'cost_owner', 'cost_approve'
]
